<template>
  <div class="row bolt-integration-form marketplace-settings">
    <div class="col-md-12">
      <section class="marketplace-action-panel marketplace-setup-panel">
        <div class="marketplace-action-heading"><i class="ti-location-pin" aria-hidden="true"></i><div><h6>{{ $t('marketplace.locations') }}</h6><p>{{ $t('marketplace.locationsSectionHint') }}</p></div></div>
        <div class="row">
    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('location_id') }">
        <label for="bolt-location_id">{{ $t('marketplace.menuLocation') }}<span v-if="isRequired('location_id')" class="text-danger"> *</span></label>
        <select
          v-model="formData.location_id"
          id="bolt-location_id"
          class="form-control"
          :disabled="disabled"
        >
          <option :value="null">{{ $t('general.select') }}</option>
          <option
            v-for="loc in locations"
            :key="'bolt-loc-' + String(loc._integrationLocationId)"
            :value="loc._integrationLocationId"
          >
            {{ loc.name }}
          </option>
        </select>
        <p class="marketplace-field-hint">{{ $t('marketplace.menuHint') }}</p>
        <span v-if="showFieldError('location_id')" class="text-danger help-block">{{ fieldErrorMessage('location_id') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('orders_location_id') }">
        <label for="bolt-orders_location_id">{{ $t('marketplace.ordersLocation') }}<span v-if="isRequired('orders_location_id')" class="text-danger"> *</span></label>
        <select
          v-model="formData.orders_location_id"
          id="bolt-orders_location_id"
          class="form-control"
          :disabled="disabled"
        >
          <option :value="null">{{ $t('general.select') }}</option>
          <option
            v-for="loc in locations"
            :key="'bolt-orders-loc-' + String(loc._integrationLocationId)"
            :value="locationOptionValue(loc)"
          >
            {{ loc.name }}
          </option>
        </select>
        <p class="marketplace-field-hint">{{ $t('marketplace.ordersHint') }}</p>
        <span v-if="showFieldError('orders_location_id')" class="text-danger help-block">{{ fieldErrorMessage('orders_location_id') }}</span>
      </div>
    </div>

        </div>
      </section>
      <section class="marketplace-action-panel marketplace-setup-panel">
        <div class="marketplace-action-heading"><i class="ti-key" aria-hidden="true"></i><div><h6>{{ $t('marketplace.credentials') }}</h6><p>{{ $t('marketplace.credentialsSectionHint') }}</p></div></div>
        <div class="row">
    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('api_url') }">
        <label>{{ fieldLabel('api_url') }}<span v-if="isRequired('api_url')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.api_url"
          :disabled="disabled"
        >
        <span v-if="showFieldError('api_url')" class="text-danger help-block">{{ fieldErrorMessage('api_url') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('integrator_id') }">
        <label>{{ fieldLabel('integrator_id') }}<span v-if="isRequired('integrator_id')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.integrator_id"
          :disabled="disabled"
        >
        <span v-if="showFieldError('integrator_id')" class="text-danger help-block">{{ fieldErrorMessage('integrator_id') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('provider_id') }">
        <label>{{ fieldLabel('provider_id') }}<span v-if="isRequired('provider_id')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.provider_id"
          :disabled="disabled"
        >
        <span v-if="showFieldError('provider_id')" class="text-danger help-block">{{ fieldErrorMessage('provider_id') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('secret_key') }">
        <label>{{ fieldLabel('secret_key') }}<span v-if="isRequired('secret_key')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.secret_key"
          :disabled="disabled"
        >
        <span v-if="showFieldError('secret_key')" class="text-danger help-block">{{ fieldErrorMessage('secret_key') }}</span>
      </div>
    </div>


        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { integrationLocationOptionValue } from 'src/components/Dashboard/Views/Integrations/integrationLocationHelpers.js'
import {
  getIntegrationFieldErrorMessage,
  hasIntegrationFieldError
} from 'src/components/Dashboard/Views/Integrations/integrationFormFieldHelpers.js'

export const DEFAULT_BOLT_API_URL = 'https://node.bolt.eu/delivery-provider-pos/genericClient'
export const DEFAULT_BOLT_SECRET_KEY = 'DRyMxJVUjn9HCHeY5UeHU3Ly'
export const DEFAULT_BOLT_USER = 'BoltProd'
export const DEFAULT_BOLT_PASSWORD = '}N31Y4-Q^wu0Q:$J'
export const DEFAULT_BOLT_MENU_LANGUAGE = 'ro-RO'

export function defaultBoltSchedule () {
  const day = {
    open: true,
    intervals: [{
      start_at_minutes_from_midnight: '10:00',
      stop_at_minutes_from_midnight: '22:00'
    }]
  }
  return Array.from({ length: 7 }, () => JSON.parse(JSON.stringify(day)))
}

export default {
  name: 'BoltIntegrationForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    topCategories: {
      type: Array,
      default: () => []
    }
  },
  created () {
    this.ensureSchedule()
    this.ensureBooleanDefaults()
    this.ensureDefaults()
  },
  methods: {
    fieldLabel (field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field)
      return field
    },
    isRequired (field) {
      return (this.requiredFields || []).includes(field)
    },
    hasFieldError (field) {
      return Boolean(this.validationErrors && this.validationErrors[field])
    },
    showFieldError (field) {
      return hasIntegrationFieldError({
        field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      })
    },
    fieldErrorMessage (field) {
      return getIntegrationFieldErrorMessage({
        field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      })
    },
    locationOptionValue (loc) {
      return integrationLocationOptionValue(loc)
    },
    ensureSchedule () {
      if (!Array.isArray(this.formData.schedule) || !this.formData.schedule.length) {
        this.$set(this.formData, 'schedule', defaultBoltSchedule())
      }
    },
    ensureBooleanDefaults () {
      const boolFields = [
        'active',
        'has_own_delivery',
        'is_auto_accept'
      ]
      boolFields.forEach(f => {
        if (this.formData[f] === undefined || this.formData[f] === null || this.formData[f] === '') {
          this.$set(this.formData, f, false)
        } else {
          this.$set(this.formData, f, Boolean(this.formData[f]))
        }
      })
    },
    ensureDefaults () {
      const defaults = {
        api_url: DEFAULT_BOLT_API_URL,
        secret_key: DEFAULT_BOLT_SECRET_KEY,
        user: DEFAULT_BOLT_USER,
        password: DEFAULT_BOLT_PASSWORD,
        menu_language: DEFAULT_BOLT_MENU_LANGUAGE
      }
      Object.entries(defaults).forEach(([key, value]) => {
        const current = this.formData[key]
        if (current === undefined || current === null || String(current).trim() === '') {
          this.$set(this.formData, key, value)
        }
      })
      if (this.formData.emails === undefined || this.formData.emails === null) {
        this.$set(this.formData, 'emails', '')
      }
    }
  }
}
</script>

<style scoped>
.bolt-integration-form .has-error .form-control { border-color: #dc3545; }
.bolt-integration-form .help-block { margin-top: 4px; margin-bottom: 0; font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/BoltIntegrationForm.vue